import React from 'react';
import { ChevronRight } from 'lucide-react';
export function WeddingCeremonySection() {
  return <section className="bg-white py-20 px-8" data-id="element-383">
      <div className="max-w-7xl mx-auto" data-id="element-384">
        {/* Section Header */}
        <div className="text-center mb-16" data-id="element-385">
          <div className="w-16 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-386" />
          <div className="text-brand-pink text-xs tracking-[0.4em] font-light uppercase mb-4" data-id="element-387">
            Say 'I Do'
          </div>
          <h2 className="font-heading text-5xl font-normal text-neutral-900 mb-6" data-id="element-388">
            Ceremony
          </h2>
          <p className="text-lg text-neutral-600 max-w-3xl mx-auto leading-relaxed" data-id="element-389">
            A wedding ceremony marks the beginning of your forever—what better
            place to say 'I do' than at Peterson House, a Hunter Valley icon.
            Choose from three beautiful ceremony settings: our iconic Chapel,
            the romantic Front of Chapel, or the picturesque By the Vines.
          </p>
        </div>

        {/* The Chapel - Image Left on Desktop, Below Content on Mobile */}
        <div className="mb-16" data-id="element-390">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-391">
            {/* Image */}
            <div className="relative aspect-[4/3] overflow-hidden rounded border-8 border-gray-100 shadow-xl bg-gray-300 order-2 lg:order-1" data-id="element-392">
              <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/11/THE-CHAPEL-CEREMONY-Jordan-Joshua.jpg" alt="The Chapel at Peterson House" className="w-full h-full object-cover" data-id="element-393" />
            </div>
            {/* Content */}
            <div className="space-y-6 order-1 lg:order-2" data-id="element-394">
              <div className="space-y-3" data-id="element-395">
                <div className="w-12 h-0.5 bg-brand-pink" data-id="element-396"></div>
                <h3 className="text-4xl font-serif text-gray-900" data-id="element-397">
                  The Chapel
                </h3>
              </div>
              <div className="space-y-4" data-id="element-398">
                <p className="text-gray-600 text-lg leading-relaxed" data-id="element-399">
                  Welcome through grand timber doors into soaring ceilings with
                  handcrafted timber trusses and exquisite metalwork, crowned by
                  a magnificent chandelier.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Front Of Chapel - Image Right */}
        <div className="mb-16" data-id="element-400">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-401">
            {/* Content */}
            <div className="space-y-6 order-1 lg:order-1" data-id="element-402">
              <div className="space-y-3" data-id="element-403">
                <div className="w-12 h-0.5 bg-brand-pink" data-id="element-404"></div>
                <h3 className="text-4xl font-serif text-gray-900" data-id="element-405">
                  Front Of Chapel
                </h3>
              </div>
              <div className="space-y-4" data-id="element-406">
                <p className="text-gray-600 text-lg leading-relaxed" data-id="element-407">
                  Exchange vows in front of the Chapel with its gorgeous
                  sandstone backdrop, combining architectural elegance with
                  natural beauty.
                </p>
              </div>
            </div>
            {/* Image */}
            <div className="relative aspect-[4/3] overflow-hidden rounded border-8 border-gray-100 shadow-xl bg-gray-300 order-2 lg:order-2" data-id="element-408">
              <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/11/FRONT-OF-CHAPEL-CEREMONY-anne-marie-denis-0242_websize.jpg" alt="Front Of Chapel ceremony setting" className="w-full h-full object-cover" data-id="element-409" />
            </div>
          </div>
        </div>

        {/* By the Vines - Image Left */}
        <div data-id="element-410">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-411">
            {/* Image */}
            <div className="relative aspect-[4/3] overflow-hidden rounded border-8 border-gray-100 shadow-xl bg-gray-300 order-2 lg:order-1" data-id="element-412">
              <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/11/BY-THE-VINES-CEREMONY-brad-and-bianca-storytellersweddingco-1.jpg" alt="By the Vines ceremony setting" className="w-full h-full object-cover" data-id="element-413" />
            </div>
            {/* Content */}
            <div className="space-y-6 order-1 lg:order-2" data-id="element-414">
              <div className="space-y-3" data-id="element-415">
                <div className="w-12 h-0.5 bg-brand-pink" data-id="element-416"></div>
                <h3 className="text-4xl font-serif text-gray-900" data-id="element-417">
                  By the Vines
                </h3>
              </div>
              <div className="space-y-4" data-id="element-418">
                <p className="text-gray-600 text-lg leading-relaxed" data-id="element-419">
                  Marry surrounded by the true nature of the Hunter Valley, with
                  vineyard rows creating an intimate and romantic outdoor
                  ceremony space.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}